import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import Loader from '../../../components/utils/Loader';
import { isEmpty } from 'lodash';
import { ItemRow } from './ItemRow';
import { TableHeader } from './TableHeader';
import { useDispatch } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { styles } from '../styles';
import { PaginationList } from './PaginationList';
import { fetchBlockedOrders } from '../../../action/blockedOrders';
import { fetchFilials } from '../../../action/handbook';

export function BlockedOrdersList() {
    const dispatch = useDispatch();
    const loaderList = useSelector(state => state.loaders.blockedOrders);
    const loaderFilials = useSelector(state => state.loaders.filials);
    const list = useSelector(state => state.blockedOrders.list);
    const loading = loaderList || loaderFilials;

    useEffect(() => ReactTooltip.rebuild(), [list, loaderList]);

    useEffect(() => {
        dispatch(fetchBlockedOrders());
        dispatch(fetchFilials(null, true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    return (
        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid" style={{ padding: 0 }}>
            <div className="kt-portlet kt-portlet--mobile">
                <div className="kt-portlet__body kt-portlet__body--fit">
                    <div
                        style={{ position: 'relative', marginBottom: 0 }}
                        className={
                            cn('kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded', {
                                'kt-datatable--error': isEmpty(list)
                            })
                        }>
                        {loading && <div style={styles.tableLoading}><Loader text='Загружаю данные'/></div>}
                        <table className="kt-datatable__table">
                            {window.innerWidth >= 550 && <TableHeader />}
                                <tbody className="kt-datatable__body">
                                    {
                                        loading
                                            ? null
                                            : isEmpty(list)
                                                ? <tr><td colSpan={8}><span className="kt-datatable--error">Заблокированных заказов нет</span></td></tr>
                                                : list.map((item) => <ItemRow key={item.id} item={item} />)
                                    }
                                </tbody>
                        </table>
                        {list.length > 0 && <PaginationList />}
                    </div>
                </div>
            </div>
           
            <ReactTooltip
                effect="solid"
                type="dark"
                place="top"
            />
        </div>
    );
}